import type { PropsPantalla } from './tipos';

/** El `?apartado=` de la ruta de una entrada anidada (`/avisos?apartado=tus`); sin él, su clave sin el prefijo. */
export function valorDeApartado(clave: string, ruta: string, prefijo: string): string {
    return new URLSearchParams(ruta.split('?')[1] ?? '').get('apartado') ?? clave.replace(new RegExp(`^${prefijo}`), '');
}

/** La ruta de otro apartado de la misma madre (`?apartado=`), o null si la persona no lo tiene. */
export function rutaDeApartado(props: Pick<PropsPantalla, 'anidadas' | 'ruta'>, clave: string, prefijo: string): string | null {
    const e = (props.anidadas ?? []).find((x) => x.clave === clave && x.anidadaComo === 'section' && !x.noContratada);
    if (e === undefined) {
        return null;
    }
    return e.ruta.includes('?') ? e.ruta : `${props.ruta.split('?')[0] ?? ''}?apartado=${encodeURIComponent(valorDeApartado(e.clave, e.ruta, prefijo))}`;
}
